(function (Translator) {
    // pl
    Translator.add("address", "Adres:", "PayseraMapBundle", "pl");
    Translator.add("friday", "Pi\u0105tek", "PayseraMapBundle", "pl");
    Translator.add("monday", "Poniedzia\u0142ek", "PayseraMapBundle", "pl");
    Translator.add("no_results", "Brak rezultat\u00f3w", "PayseraMapBundle", "pl");
    Translator.add("saturday", "Sobota", "PayseraMapBundle", "pl");
    Translator.add("search_placeholder", "Wpisz fragment", "PayseraMapBundle", "pl");
    Translator.add("service.cash_in", "Wp\u0142ata got\u00f3wki", "PayseraMapBundle", "pl");
    Translator.add("service.cash_out", "Wyp\u0142ata got\u00f3wki", "PayseraMapBundle", "pl");
    Translator.add("service.identification", "Wykonanie identyfikacji", "PayseraMapBundle", "pl");
    Translator.add("service.pay", "P\u0142atno\u015bci", "PayseraMapBundle", "pl");
    Translator.add("services", "Us\u0142ugi:", "PayseraMapBundle", "pl");
    Translator.add("sunday", "Niedziela", "PayseraMapBundle", "pl");
    Translator.add("thursday", "Czwartek", "PayseraMapBundle", "pl");
    Translator.add("tuesday", "Wtorek", "PayseraMapBundle", "pl");
    Translator.add("wednesday", "\u015aroda", "PayseraMapBundle", "pl");
    Translator.add("working_hours", "Czas pracy:", "PayseraMapBundle", "pl");
})(Translator);
